import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=3bde1e61&scoped=true&"
import script from "./BigNumber.vue?vue&type=script&lang=js&"
export * from "./BigNumber.vue?vue&type=script&lang=js&"
import style0 from "./BigNumber.vue?vue&type=style&index=0&id=3bde1e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde1e61",
  null
  
)

component.options.__file = "BigNumber.vue"
export default component.exports